import React from 'react';
import {enToFa} from '../utils/NumberUtility'

const Pagination = (props) => {

    return (
        <div className="optimized__d-flex-class justify-content-between align-items-center my-3">
            <button disabled={props.currentPage === 1} className="pagination__button p-2" onClick={props.handlePrev}>صفحه قبل</button>
            <span className="pagination__page-number">{`صفحه ${enToFa(props.currentPage || 1)} از ${enToFa(props.pageCount || 1)}`}</span>
            <button disabled={props.currentPage >= props.pageCount} className="pagination__button p-2" onClick={props.handleNext}>صفحه بعد</button>
        </div>
    );
}

export default Pagination;